export const wiki = {
  wiki: 'ویکی',
  homeH1: 'ویکی اسکین‌های CS2',
  homeSubtitle: 'همه اسکین‌های CS2: فرسودگی، کمیابی، کیس‌ها و کالکشن‌ها',
  categoriesTitle: 'دسته‌ها',
  featuredTitle: 'اسکین‌های بررسی‌شده',
  allWeaponsTitle: 'همه سلاح‌ها',
  aboutWiki: 'درباره ویکی',
  readMore: 'ادامه مطلب',
  showAll: 'نمایش همه {{count}} مورد',
  floatScaleLabel: 'مقیاس float از 0 تا 1 و وضعیت فرسودگی در هر بازه',
  searchPlaceholder: 'یک اسکین، سلاح یا کیس پیدا کن',
  searchPlaceholderShort: 'اسکین، سلاح یا کیس',
  searchSubmit: 'جستجو',
  searchClear: 'پاک کردن جستجو',
  searchH1: 'جستجو در ویکی',
  searchResultsFor: 'نتایج برای «{{q}}»',
  searchEmptyTitle: 'چیزی پیدا نشد',
  searchEmptyText: 'املا را بررسی کن یا نام انگلیسی را امتحان کن.',
  searchEmptyTextLatin: 'املا را بررسی کن یا عبارت را کوتاه‌تر کن.',
  searchOpenCatalog: 'باز کردن کاتالوگ',
  searchErrorTitle: 'جستجو بارگذاری نشد',
  searchErrorText: 'اتصالت را بررسی کن و دوباره جستجو کن.',
  searchShortQuery: 'حداقل دو حرف بنویس.',
  retry: 'تلاش دوباره',
  suggestEmpty: 'موردی پیدا نشد',
  suggestAll: 'نمایش همه نتایج',
  typeSkin: 'اسکین',
  typeWeapon: 'سلاح',
  typeContainer: 'کیس',
  typeCollection: 'کالکشن',
  catPistols: 'تپانچه‌ها',
  catRifles: 'تفنگ‌ها',
  catSmgs: 'مسلسل‌های سبک',
  catHeavy: 'سلاح‌های سنگین',
  catKnives: 'چاقوها',
  catGloves: 'دستکش‌ها',
  catEquipment: 'تجهیزات',
  weaponsTitle: 'سلاح‌ها',
  modelsTitle: 'مدل‌ها',
  selectionsTitle: 'مجموعه‌ها',
  guidesTitle: 'راهنماها',
  containersTitle: 'جدیدترین کیس‌ها',
  allSkins: 'همه اسکین‌ها',
  allGuides: 'همه راهنماها',
  allSelections: 'همه مجموعه‌ها',
  allCases: 'همه کیس‌ها',
  allCollections: 'همه کالکشن‌ها',
  skinsOne: '{{count}} اسکین',
  skinsFew: '{{count}} اسکین',
  skinsMany: '{{count}} اسکین',
  knivesOne: '{{count}} چاقو',
  knivesFew: '{{count}} چاقو',
  knivesMany: '{{count}} چاقو',
  glovesOne: '{{count}} جفت دستکش',
  glovesFew: '{{count}} جفت دستکش',
  glovesMany: '{{count}} جفت دستکش',
  rareItemsOne: '{{count}} آیتم',
  rareItemsFew: '{{count}} آیتم',
  rareItemsMany: '{{count}} آیتم',
  skinsPlusRare: '{{skins}} + {{rare}}',
  catalogH1: 'اسکین‌های CS2',
  catalogCategoryH1: 'اسکین‌های CS2: {{category}}',
  filtersTitle: 'فیلترها',
  filterWeapon: 'سلاح',
  filterRarity: 'کمیابی',
  filterCollection: 'کالکشن',
  filterCase: 'کیس',
  filterExterior: 'فرسودگی',
  filterStatTrak: 'دارای StatTrak™',
  filterSouvenir: 'دارای Souvenir',
  anyWeapon: 'هر سلاحی',
  anyRarity: 'هر کمیابی',
  anyCollection: 'هر کالکشنی',
  anyCase: 'هر کیسی',
  removeFilter: 'حذف فیلتر «{{name}}»',
  sortLabel: 'مرتب‌سازی',
  sortRarity: 'بر اساس کمیابی',
  sortName: 'بر اساس نام',
  sortRelease: 'جدیدترین‌ها اول',
  sortPrice: 'بر اساس قیمت',
  applyFilters: 'نمایش',
  resetFilters: 'بازنشانی فیلترها',
  resetShort: 'بازنشانی',
  closeFilters: 'بستن فیلترها',
  catalogEmptyTitle: 'اسکینی با این فیلترها پیدا نشد',
  catalogEmptyText: 'چند فیلتر را بردار یا همه را بازنشانی کن.',
  prevPage: 'قبلی',
  nextPage: 'بعدی',
  pageOf: 'صفحه {{page}} از {{count}}',
  foundCount: 'پیدا شد: {{count}}',
  foundCountMasculine: 'پیدا شد: {{count}}',
  priceFrom: 'از {{price}}',
  weaponAllFilters: 'همه فیلترها در کاتالوگ',
  breadcrumbs: 'مسیر صفحه',
  exteriorFn: 'نو از کارخانه',
  exteriorMw: 'کمی فرسوده',
  exteriorFt: 'آزموده‌شده در میدان',
  exteriorWw: 'بسیار فرسوده',
  exteriorBs: 'زخم‌خورده از نبرد',
  kindNormal: 'معمولی',
  kindStatTrak: 'StatTrak™',
  kindSouvenir: 'Souvenir',
  vanillaFinish: 'بدون طرح',
  phasesTitle: 'فازها',
  statsTitle: 'مشخصات',
  statWeapon: 'سلاح',
  statFinish: 'طرح',
  statRarity: 'کمیابی',
  statFloat: 'بازه float',
  statExteriors: 'فرسودگی',
  statKinds: 'نسخه‌ها',
  statCollections: 'کالکشن',
  statContainers: 'کیس‌ها',
  statRelease: 'سال انتشار',
  rareItem: 'آیتم ویژه کمیاب',
  rareDropNote: 'به‌عنوان آیتم ویژه کمیاب دراپ می‌شود ★',
  pricesTitle: 'قیمت‌ها در Steam',
  pricesHint: 'قیمت در بازار انجمن Steam به دلار آمریکا.',
  priceAsOf: 'به‌روزرسانی: {{date}}.',
  noPrice: 'داده به‌روزی نیست',
  noPriceMarked: 'برای نسخه‌های انتخاب‌شده داده به‌روزی نیست',
  gameDescriptionTitle: 'توضیح داخل بازی',
  faqTitle: 'پرسش‌های متداول',
  similarTitle: 'اسکین‌های مشابه',
  shotTitle: 'در SHOT موجود است',
  shotHint: 'این اسکین در این کیس‌های SHOT هست.',
  dropsTitle: 'دراپ‌های اخیر',
  dropsHint: 'چه کسی و کجا آن را در SHOT گرفته.',
  dropsCase: 'کیس «{{name}}»',
  dropsCaseBattle: 'نبرد کیس',
  dropsUpgrade: 'ارتقا',
  dropsContract: 'قرارداد',
  dropsRushMid: 'Rush Mid',
  dropsRoulette: 'رولت روسی',
  timeJustNow: 'همین الان',
  timeMinutesAgo: '{{count}} دقیقه پیش',
  timeHoursAgo: '{{count}} ساعت پیش',
  timeDaysAgo: '{{count}} روز پیش',
  englishName: 'نام انگلیسی',
  caseReleased: 'منتشرشده در {{year}}',
  rareTitle: 'آیتم‌های ویژه کمیاب',
  compositionTitle: 'اسکین‌های داخل کیس',
  rareHintKnives: 'چاقوها از این کیس به‌عنوان یک آیتم ویژه کمیاب جدا دراپ می‌شوند.',
  rareHintGloves: 'دستکش‌ها از این کیس به‌عنوان یک آیتم ویژه کمیاب جدا دراپ می‌شوند.',
  rareHintKnivesAndGloves: 'چاقوها و دستکش‌ها از این کیس به‌عنوان یک آیتم ویژه کمیاب جدا دراپ می‌شوند.',
  rareKnives: 'چاقوها',
  rareGloves: 'دستکش‌ها',
  rareKnivesAndGloves: 'چاقوها و دستکش‌ها',
  caseCollectionTitle: 'کالکشن کیس',
  collectionCasesTitle: 'کیس‌های این کالکشن',
  collectionReleased: 'منتشرشده در {{year}}',
  tocTitle: 'فهرست مطالب',
  reviewedOn: 'بررسی‌شده در {{date}}',
  reviewedBy: 'بررسی‌شده توسط تیم SHOT · {{date}}',
  shortAnswer: 'پاسخ کوتاه',
  guidesH1: 'راهنمای اسکین‌های CS2',
  selectionsH1: 'مجموعه‌های اسکین CS2',
  casesH1: 'کیس‌های CS2',
  collectionsH1: 'کالکشن‌های CS2',
  weaponSkinsH1: 'اسکین‌های {{weapon}}',
};

export const wikiItem = {
  typeSticker: 'استیکر',
  typeAgent: 'ایجنت',
  typeCharm: 'آویز',
  typeMusicKit: 'کیت موسیقی',
  typePatch: 'پچ',
  typeGraffiti: 'گرافیتی',
  typePin: 'پین',
  sectionStickers: 'استیکرها',
  sectionAgents: 'ایجنت‌ها',
  sectionCharms: 'آویزها',
  sectionMusicKits: 'کیت‌های موسیقی',
  sectionPatches: 'پچ‌ها',
  sectionGraffiti: 'گرافیتی‌ها',
  sectionPins: 'پین‌ها',
  kindCase: 'کیس',
  kindStickerCapsule: 'کپسول استیکر',
  kindAutographCapsule: 'کپسول امضا',
  kindSouvenirPackage: 'بسته Souvenir',
  kindMusicKitBox: 'جعبه کیت موسیقی',
  kindPatchCapsule: 'بسته پچ',
  kindPinsCapsule: 'کپسول پین',
  kindGraffitiBox: 'جعبه گرافیتی',
  tabAll: 'همه',
  tabCases: 'کیس‌ها',
  tabStickerCapsules: 'کپسول‌های استیکر',
  tabAutographCapsules: 'کپسول‌های امضا',
  tabSouvenirPackages: 'بسته‌های Souvenir',
  tabMusicKitBoxes: 'جعبه‌های کیت موسیقی',
  tabPatchCapsules: 'بسته‌های پچ',
  tabPinsCapsules: 'کپسول‌های پین',
  tabGraffitiBoxes: 'جعبه‌های گرافیتی',
  kindsNavLabel: 'نوع کانتینر',
  containersH1: 'کیس‌ها و کپسول‌های CS2',
  h1StickerCapsules: 'کپسول‌های استیکر CS2',
  h1AutographCapsules: 'کپسول‌های امضای CS2',
  h1SouvenirPackages: 'بسته‌های Souvenir در CS2',
  h1MusicKitBoxes: 'جعبه‌های کیت موسیقی CS2',
  h1PatchCapsules: 'بسته‌های پچ CS2',
  h1PinsCapsules: 'کپسول‌های پین CS2',
  h1GraffitiBoxes: 'جعبه‌های گرافیتی CS2',
  stickersOne: '{{count}} استیکر',
  stickersFew: '{{count}} استیکر',
  stickersMany: '{{count}} استیکر',
  musicKitsOne: '{{count}} کیت موسیقی',
  musicKitsFew: '{{count}} کیت موسیقی',
  musicKitsMany: '{{count}} کیت موسیقی',
  patchesOne: '{{count}} پچ',
  patchesFew: '{{count}} پچ',
  patchesMany: '{{count}} پچ',
  pinsOne: '{{count}} پین',
  pinsFew: '{{count}} پین',
  pinsMany: '{{count}} پین',
  graffitiOne: '{{count}} گرافیتی',
  graffitiFew: '{{count}} گرافیتی',
  graffitiMany: '{{count}} گرافیتی',
  colorsOne: '{{count}} رنگ',
  colorsFew: '{{count}} رنگ',
  colorsMany: '{{count}} رنگ',
  inGameSince: 'در بازی از {{year}}',
  contentsTitle: 'داخلش چیست',
  variantsTitle: 'نسخه‌ها',
  groupSticker: 'استیکر',
  groupSlab: 'در اسلب',
  effectPaper: 'کاغذی',
  effectHolo: 'هولو',
  effectFoil: 'فویل',
  effectGold: 'طلایی',
  effectGlitter: 'اکلیلی',
  effectLenticular: 'لنتیکولار',
  effectEmbroidered: 'گلدوزی‌شده',
  stickerAutograph: 'امضا',
  stickerTeam: 'تیم',
  stickerEvent: 'تورنمنت',
  stickerOther: 'سایر',
  sideT: 'تروریست‌ها',
  sideCt: 'ضدتروریست‌ها',
  statType: 'نوع',
  statStickerKind: 'نوع استیکر',
  statTournament: 'تورنمنت',
  statTeam: 'تیم',
  statPlayer: 'بازیکن',
  statEffects: 'افکت‌ها',
  statSlab: 'در اسلب',
  statSide: 'سمت',
  statArtist: 'هنرمند',
  statStatTrak: 'StatTrak™',
  statColors: 'رنگ‌ها',
  valueYes: 'موجود است',
  valueNo: 'موجود نیست',
  whereTitle: 'از کجا بگیرم',
  whereCollection: 'کالکشن',
  whereStickerPack: 'پک استیکر',
  shotHintItem: 'این آیتم از این کیس‌های SHOT دراپ می‌شود.',
  souvenirPackagesRow: 'بسته‌های Souvenir',
  moreCount: '{{count}} مورد دیگر',
  typeHighlight: 'آویز هایلایت',
  typePass: 'پاس',
  typeKey: 'کلید',
  sectionHighlights: 'آویزهای هایلایت',
  sectionPasses: 'پاس‌ها',
  sectionKeys: 'کلیدها',
  kindOther: 'بسته',
  tabOther: 'سایر',
  h1Other: 'سایر بسته‌های CS2',
  itemsOne: '{{count}} آیتم',
  itemsFew: '{{count}} آیتم',
  itemsMany: '{{count}} آیتم',
  statEvent: 'تورنمنت',
  statStage: 'مرحله',
  statMap: 'مپ',
  statTeams: 'مسابقه',
  statVideo: 'ویدیو',
  watchVideo: 'تماشای لحظه',
  statOpens: 'باز می‌کند',
  listH1Stickers: 'استیکرهای CS2',
  listH1Agents: 'ایجنت‌های CS2',
  listH1Charms: 'آویزهای CS2',
  listH1MusicKits: 'کیت‌های موسیقی CS2',
  listH1Patches: 'پچ‌های CS2',
  listH1Graffiti: 'گرافیتی‌های CS2',
  listH1Highlights: 'آویزهای هایلایت CS2',
  listH1Pins: 'پین‌های CS2',
  listH1Passes: 'پاس‌های CS2',
  listH1Keys: 'کلیدهای کیس CS2',
  listCount: '{{count}} مورد در بازی',
  typeCollectible: 'کلکسیونی',
  sectionCollectibles: 'سکه‌ها، مدال‌ها و جام‌ها',
  listH1Collectibles: 'سکه‌ها، مدال‌ها و جام‌های CS2',
  collectibleCoin: 'سکه',
  collectibleTrophy: 'جام',
  collectibleMedal: 'مدال',
  versionNumber: 'نسخه {{n}}',
  allItemsTitle: 'همه آیتم‌ها',
  sectionContainers: 'کیس‌ها و کپسول‌ها',
};
